var Compass = {
	last:[],
	lastHeading:0,
	lastBeta:[],
	previousBeta:0,
	
	calculateHeading: function(alpha, beta, gamma) {
		var alphaRad = alpha * (Math.PI / 180);
		var betaRad = beta * (Math.PI / 180);
		var gammaRad = gamma * (Math.PI / 180);

		var cA = Math.cos(alphaRad);
		var sA = Math.sin(alphaRad);
		var cB = Math.cos(betaRad);
		var sB = Math.sin(betaRad);
		var cG = Math.cos(gammaRad);
		var sG = Math.sin(gammaRad);

		var rA = - cA * sG - sA * sB * cG;
		var rB = - sA * sG + cA * sB * cG;
		var rC = - cB * cG;

		var compassHeading = Math.atan(rA / rB);

		if(rB < 0) {
		  compassHeading += Math.PI;
		}else if(rA < 0) {
		  compassHeading += 2 * Math.PI;
		}

		compassHeading *= 180 / Math.PI;

		return compassHeading;
	},
	
	heading: function() {
		var h = Compass.calculateHeading(player.orientation.alpha, player.orientation.beta, player.orientation.gamma);
		Compass.last.push(h);
		if (Compass.last.length > 10) Compass.last.shift();
		var smooth = 0;
		
		if (Math.abs(h - Compass.lastHeading) < 300) {
			for(var i = 0; i < Compass.last.length; i ++) smooth += Compass.last[i];
			smooth /= Compass.last.length;
		} else {
			Compass.last = [];
			smooth = h;
		}
		
		Compass.lastHeading = h;		
		return smooth;
	},

	tilt: function() {
		var h = player.orientation.beta;
		
		Compass.lastBeta.push(h);
		if (Compass.lastBeta.length > 10) Compass.lastBeta.shift();
		var smooth = 0;
		
		if (Math.abs(h - Compass.previousBeta) < 300) {
			for(var i = 0; i < Compass.lastBeta.length; i ++) smooth += Compass.lastBeta[i];
			smooth /= Compass.lastBeta.length;
		} else {
			Compass.lastBeta = [];
			smooth = h;
		}
		
		Compass.previousBeta = h;		
		return smooth;
	}
	
}